module.exports = "<label #prefixLabel *ngIf=\"prefix\">{{ prefix }}</label>\n<input type=\"text\"\n       class=\"{{ format }}-format icon-{{ icon }}\"\n       [class.icon]=\"icon\"\n       [(ngModel)]=\"innerValue\"\n       [disabled]=\"disabled\"\n       [attr.id]=\"id\"\n       [attr.name]=\"name\"\n       [placeholder]=\"placeholder | translate\"\n       [ngStyle]=\"{'padding-left': paddingLeft}\">\n<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-text/ui-text.html
// module id = 1080
// module chunks = 3